import { render, staticRenderFns } from "./ExportLogTable.vue?vue&type=template&id=20600dc1&"
import script from "./ExportLogTable.vue?vue&type=script&lang=js&"
export * from "./ExportLogTable.vue?vue&type=script&lang=js&"
import style0 from "./ExportLogTable.vue?vue&type=style&index=0&id=20600dc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports